module.exports = __webpack_public_path__ + "static/server-start-bdf99f9806dff7e0ac72cd89fce96e93.png";